import { render, staticRenderFns } from "./mock-record.vue?vue&type=template&id=05d3ace2&scoped=true"
import script from "./mock-record.vue?vue&type=script&lang=js"
export * from "./mock-record.vue?vue&type=script&lang=js"
import style0 from "./mock-record.vue?vue&type=style&index=0&id=05d3ace2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3ace2",
  null
  
)

export default component.exports